import { IColumn, ICommandBarItemProps } from "@fluentui/react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { useTableDispositivoHistorico } from "../../../../hooks/TablasHooks/useTableDispositivoHistorico";
import { TableBase2 } from "../../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../../components/PaginationFooter/PaginationFooterC";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelFilterDispositivoHistorico } from "./PanelFilterDispositivoHistorico";
import { useEffect } from "react";

export const DispositivoHistorico = () => {
  const {
    itemsDsp,
    loading,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearchDispositivo,
    onChangeSkip,
    onChangeComboBox,
    onSelectDate,
    filterFechas,
    limpiarFiltro,
    filterReporte,
    getDataTable,
    Actualizar
  } = useTableDispositivoHistorico();

  const [
    isOpenFilter,
    { setTrue: openPanelFilter, setFalse: onDismissFilter },
  ] = useBoolean(false);

  useEffect(() => {
    getDataTable();
  }, []);

  const column: IColumn[] = [
    {
      key: "persona",
      name: "Persona",
      fieldName: "persona",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "nroDoi",
      name: "DNI",
      fieldName: "nroDoi",
      minWidth: 80,
      maxWidth: 80,
      isResizable: false,
      onRender: (item: any) => (
        <span style={{ fontWeight: "bold", fontSize: 12 }}>{item.nroDoi}</span>
      ),
    },
    {
      key: "guardia",
      name: "Guardia",
      fieldName: "guardia",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "area",
      name: "Área",
      fieldName: "area",
      minWidth: 160,
      maxWidth: 160,
      isResizable: true,
    },
    {
      key: "modelo",
      name: "Modelo Equipo",
      fieldName: "modeloEquipo",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "fabricante",
      name: "Fabricante",
      fieldName: "fabricante",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
    },
    {
      key: "serie",
      name: "Serie",
      fieldName: "serie",
      minWidth: 80,
      maxWidth: 80,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "codigo",
      name: "Código",
      fieldName: "codigo",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
    },
    {
      key: "fechaEntrega",
      name: "Fecha Entrega",
      fieldName: "fechaEntrega",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "horaEntrega",
      name: "Hora Entrega",
      fieldName: "horaEntrega",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "fechaDevolucion",
      name: "Fecha Devolución",
      fieldName: "fechaDevolucion",
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "horaDevolucion",
      name: "Hora Devolución",
      fieldName: "horaDevolucion",
      minWidth: 90,
      maxWidth: 90,
      isResizable: true,
    },
  ];
  const left_items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        Actualizar();
      },
    },
  ];
  const rigth_items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BS_FILTER,
      onClick: () => {
        openPanelFilter();
      },
      text: 'Buscar'
    },
  ];
  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Código"
            componentRef={searchBoxRefTable}
            Titulo="Dispositivo"
            SubTitulo="Histórico de Dispositivo"
            onKeyUp={_onkeyUpSearchDispositivo}
          />
        </div>
      </div>
      <br />
      <TableBase2
        leftBar={left_items}
        rigthBar={rigth_items}
        data={itemsDsp}
        column={column}
        isLoading={loading}
        footerPagination={
          <PaginationFooterC
            paginacion={paginacion}
            onChangePagina={(e) => {
              onChangeSkip(e);
            }}
          />
        }
      />
      <PanelFilterDispositivoHistorico
        isOpen={isOpenFilter}
        onDismiss={onDismissFilter}
        onChangeComboBox={onChangeComboBox}
        onSelectDate={onSelectDate}
        filterFechas={filterFechas}
        limpiarFiltro={limpiarFiltro}
        filterReporte={filterReporte}
        buscar={getDataTable}
      />
    </>
  );
};
